import { Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import api from "../../components/services/api";
import { useParams } from "react-router";
import moment from 'moment';
import Logo from "../../images/Screenshot_2023-09-21_113739-transformed.png";

export default function CargoReceipt() {
    let { id } = useParams();
    const [locationData, setLocationData] = useState([]);
    const [container, setContainer] = useState([]);
    const [packageData, setPackageData] = useState([])

    const [data, setData] = useState();
    const [transportation, setTransportation] = useState();
    const getData = async () => {
        const res = await api(`api/saleorder/detail/bookinginfo/${id}`);
        const data = await res.data;
        setData(data);
    };
    const getTransportation = async () => {
        const res = await api(`api/saleorder/detail/transportation/${id}`);
        const data = await res.data;
        setTransportation(data);
    };
    const getMasterPackage = async () => {
        try {
            const res = await api.get("api/master/package");
            const data = await res.data
            if (res.meta.status === true) {
                setPackageData(data.data)
            }
        } catch (e) {
            console.log(e);
        }
    };
    const getLocation = async () => {
        try {
            const res = await api.get("api/location/list");
            const data = await res.data
            if (res.meta.status === true) {
                setLocationData(data);
            }
        } catch (e) {
            console.log(e);
        }
    };
    const getContainer = async () => {
        const res = await api(`api/saleorder/detail/container/${id}`);
        const data = await res.data;
        setContainer(data);
    };
    useEffect(() => {
        getData()
        getTransportation()
        getLocation()
        getContainer()
        getMasterPackage()
    }, [])

    const pageCount = Math.ceil(container?.length / 10)
    const rows = [];
    for (let pageIndex = 0; pageIndex < pageCount; pageIndex++) {
        rows.push(<>
            <page>
                <div class="titleR" style={{marginTop:'0px'}}>
                    <h2 style={{ fontWeight: 'bold', color: "#0066cc" }}>ORIGINAL</h2>
                </div>
                <div class="content">
                    <div className="rowR" style={{ flexDirection: "column" }}>
                        <p className="header_p">Shipper</p>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <p>{data?.ShipperRefNo}</p>
                            <p>{ }</p>

                        </div>
                        <p className="header_p">Consignee</p>
                        <div style={{ display: "flex", flexDirection: "column", height: "50px" }}>
                            <p></p>
                        </div>
                        <p className="header_p" style={{ marginTop: '10px' }}>Notify party (carrier not to be responsible for failure to notify)</p>
                        <div style={{ display: "flex", flexDirection: "column", height: "100px" }}>

                        </div>
                    </div>



                    <div className="rowR" style={{ flexDirection: "column", height: 'fit-content' }}>
                        <div className="rowR" style={{ height: 'fit-content' }}>
                            <p className="header_p" style={{ height: 'fit-content' }}>B/L No.</p>
                            <p style={{ height: 'fit-content' }}>{data?.BookingNo}</p>
                        </div>
                        <p>APILOGISTICZ CO., LTD.</p>
                        <p>CARGO RECEIPT</p>
                        <hr style={{ marginBottom: "5px", marginTop: "5px" }} />
                        <hr style={{ marginBottom: "5px", marginTop: "5px" }} />
                        <p>shipping agent references (complete name and address)</p>
                        <div style={{ display: "flex", justifyContent: 'end' }}>
                            <p style={{ flexBasis: '25%' }}>Shipper Invoice No.</p>
                            <p style={{ flexBasis: '10%' }}>{data?.ShipperInvoiceNo}</p>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            <p>APILOGISTICZ CO., LTD.</p>
                            <p>160 RASSADA ROAD </p>
                            <p>TEL : (66)-75-253290</p>
                            <p>FAX : (66)-75-253292</p>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <hr style={{ marginBottom: "5px", marginTop: "0px", width: "100%" }} />
                    <p style={{ marginBottom: "0px", fontSize: "18px" }}>Ocean vessel / Voy No.</p>
                    <div className="rowR" style={{ flexBasis: '100%' }}>
                        <p>{data?.FeederVessel || '-'}</p>
                        <p>{transportation?.OutboundVoyNo}</p>
                    </div>
                    <hr style={{ marginBottom: "5px", marginTop: "5px", width: "100%" }} />
                    <div className="rowR" style={{ flexBasis: '100%' }}>
                        <p style={{ fontSize: "18px" }}>Port of loading</p>
                        <p style={{ fontSize: "18px" }}>Place of receipt</p>
                    </div>
                    <div className="rowR" style={{ flexBasis: '100%' }}>
                        <p>{locationData?.find((x) => x?.LocationId === transportation?.InboundGateOutId)?.LocationName || '-'}, {locationData?.find((x) => x?.LocationId === transportation?.OutboundGateOutId)?.LocationName || '-'}</p>
                        <p>{locationData?.find((x) => x?.LocationId === transportation?.InboundGateOutId)?.LocationName || '-'}, {locationData?.find((x) => x?.LocationId === transportation?.OutboundGateOutId)?.LocationName || '-'}</p>
                    </div>
                    <hr style={{ marginBottom: "5px", marginTop: "5px", width: "100%" }} />
                    <div className="rowR" style={{ flexBasis: '100%' }}>
                        <p style={{ fontSize: "18px" }}>Port of discharge</p>
                        <p style={{ fontSize: "18px" }}>Place of delivery</p>
                    </div>
                    <div className="rowR" style={{ flexBasis: '100%' }}>
                        <p>{locationData?.find((x) => x?.LocationId === data?.POLLocationId)?.LocationName || '-'},{locationData?.find((x) => x?.LocationId === data?.PODLocationId)?.LocationName || '-'}</p>
                        <p>{locationData?.find((x) => x?.LocationId === data?.POLLocationId)?.LocationName || '-'}, {locationData?.find((x) => x?.LocationId === data?.PODLocationId)?.LocationName || '-'}</p>
                    </div>

                </div>
                <div class="content">
                    <p style={{ marginBottom: "0px", fontSize: "16px" }}>Shipper load and count, weight, quantity, quality, measurement unknown.</p>
                    <p style={{ marginBottom: "0px", fontSize: "16px" }}>(of which all cargo on deck at Shipper’s risk: the Carrier not being responsible for loss or damage howsoever arising )</p>
                </div>
                <div class="content">

                    <hr style={{ marginBottom: "5px", marginTop: "5px", width: "100%" }} />
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <div className="rowR" style={{ flexBasis: '20%', flexDirection: "column", }}>
                            <h5>Container No.</h5>
                            <span>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[0]?.ContainerNo}</span>
                            <span>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[1]?.ContainerNo}</span>
                            <span>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[2]?.ContainerNo}</span>
                            <span>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[3]?.ContainerNo}</span>
                            <span>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[4]?.ContainerNo}</span>
                            <span>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[5]?.ContainerNo}</span>
                            <span>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[6]?.ContainerNo}</span>
                            <span>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[7]?.ContainerNo}</span>
                            <span>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[8]?.ContainerNo}</span>
                            <span>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[9]?.ContainerNo}</span>
                            <div style={{ height: '100px' }}></div>

                        </div>
                        <div className="rowR" style={{ flexBasis: '20%', flexDirection: "column", }}>
                            <h5>Seal No.</h5>
                            <span>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[0]?.SealShipper}</span>
                            <span>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[1]?.SealShipper}</span>
                            <span>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[2]?.SealShipper}</span>
                            <span>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[3]?.SealShipper}</span>
                            <span>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[4]?.SealShipper}</span>
                            <span>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[5]?.SealShipper}</span>
                            <span>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[6]?.SealShipper}</span>
                            <span>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[7]?.SealShipper}</span>
                            <span>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[8]?.SealShipper}</span>
                            <span>{container?.slice(pageIndex * 10, pageIndex * 10 + 10)[9]?.SealShipper}</span>
                        </div>
                        <div className="rowR" style={{ flexBasis: '15%', flexDirection: "column", }}>
                            <h5>Number of container or packages</h5>
                            <span>{data?.Quantity || 0} CTRS</span>
                            <span>{packageData?.find((x) => x?.PackageId === data?.PackageId)?.PackageName || '-'}</span>
                            <span>(TYPE: MB5)</span>
                        </div>
                        <div className="rowR" style={{ flexBasis: '25%', flexDirection: "column", }}>
                            <h5>Kind of Package and <br />Description of goods</h5>
                            <div style={{ height: '120px' }}></div>
                            <h5>Remark</h5>

                        </div>
                        <div className="rowR" style={{ flexBasis: '20%', flexDirection: "column", }}>
                            <h5>Gross weight / Net Weight</h5>
                            <span>Gross Weight</span>
                            <span>{container?.map((s) => s?.CargoWeight)?.reduce((a, b) => a + b)}</span>
                            <span>KGS</span>
                            <span style={{ height: '15px' }} ></span>
                            <span>CBM</span>
                            <span>Net weight</span>
                            <span>{container?.map((s) => s?.VGMWeight)?.reduce((a, b) => a + b)}</span>
                            <span>KGS</span>
                        </div>
                    </div>
                </div>
                <div className="containerR">
                    <table border="1" cellpadding="10" cellspacing="0" style={{ width: '100%' }}>
                        <tr style={{ border: '1px solid' }}>
                            <th style={{ border: '1px solid' }}>
                                Freight payable at
                            </th>
                            <th style={{ border: '1px solid' }}>
                                Ex. Rate
                            </th>
                            <th style={{ border: '1px solid' }}>
                                No. of original B(s)/L
                            </th>
                            <th style={{ border: '1px solid' }}>
                                Place and date of issue
                            </th>

                        </tr>

                        <tr style={{ border: '1px solid', fontSize: '16px', height: '27px' }}>
                            <td style={{ border: '1px solid' }}>LOADING PORT</td>
                            <td style={{ border: '1px solid' }}>{ }</td>
                            <td style={{ border: '1px solid' }}>{ }</td>
                            <td style={{ border: '1px solid' }}>{locationData?.find((x) => x?.LocationId === transportation?.OutboundGateOutId)?.LocationName || '-'} <span style={{ marginRight: '10px' }}></span>{transportation?.InboundETDGateOut ? moment(transportation?.InboundETDGateOut).format('DD/MM/YYYY') : '-'}</td>

                        </tr>
                    </table>

                </div>
                <div class="content">
                    <div className="rowR">

                        <div className="rowR" style={{ flexBasis: "100%" }}>
                            <p className="header_p">Laden on board </p>
                            <div className="rowR">
                                <div style={{ display: "flex", flexDirection: "column" }}>

                                </div>
                                <div style={{ display: "flex", flexDirection: "column" }}>
                                    <p className="header_p">Date</p>

                                    <p>{transportation?.InboundETDGateOut ? moment(transportation?.InboundETDGateOut).format('DD/MM/YYYY') : '-'}</p>
                                    <p>{transportation?.InboundVoyNo ? transportation?.InboundVoyNo : '-'}</p>
                                    <p>{locationData?.find((x) => x?.LocationId === transportation?.InboundGateOutId)?.LocationName || '-'}, {locationData?.find((x) => x?.LocationId === transportation?.OutboundGateOutId)?.LocationName || '-'}</p>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="rowR">
                        <div style={{ display: "flex", flexDirection: "column", position:"relative" }}>
                            <p>Yours faithfully:</p>
                            <p>(Signature/Company/Stamp)</p>
                            {/* <img src={Logo} alt='aa' width={200} style={{position:"absolute", top:'20px'}}/> */}
                        </div>
                    </div>
                </div>
            </page>
        </>
        )
    }
    return (

        <>
            {rows}
        </>

    );
}
